import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  private sharedData: any;
  onDrawerChange: Subject<any> = new BehaviorSubject({});
  constructor() {}
  setSharedData(data: any): void {
    this.sharedData = data;
    this.onDrawerChange.next(this.sharedData);
    this.sharedData = {};
  }
}
